import { compose, branch, withHandlers, renderNothing } from 'recompose';
import { connect } from 'react-redux';
import { getCustomerCard, getHasCustomerCard } from '../../customer/selectors';
import withCardCharge from '../hoc/withCardCharge';
import { getCard, getHasCard } from '../reducer/card/selectors';
import Charge from '../components/Charge';
import { getIsFetching } from '../reducer/isFetching/selectors';
import { closePayment } from '../reducer/currentPayment/actions';

const CardChargeContainer = compose(
  withCardCharge,
  connect(
    (state) => {
      const hasCard = getHasCustomerCard(state) || getHasCard(state);
      return {
        hasCard,
        card: getCustomerCard(state) || getCard(state),
        disabled: !hasCard || getIsFetching(state),
      };
    },
    { closePayment }
  ),
  withHandlers({
    charge: props => () => {
      props.cardCharge(props.card);
      if (props.onCharge) {
        props.onCharge(props.card);
      }
    },
  }),
  branch(
    props => !props.hasCard,
    renderNothing,
  )
)(Charge);

export default CardChargeContainer;
